import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import App from './app/app';

if (import.meta.env.MODE === 'production' && import.meta.env.APP_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.APP_SENTRY_DSN,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend: event => {
      const toIgnore = [
        'Token invalid',
        'Auth error',
        'The user aborted a request',
        'Fetch is aborted',
        'ValidationError',
        'pagead',
        'Failed to fetch',
        'API timeout',
        'The operation was aborted.',
      ];

      // Ignore events from localhost
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return null;
      }

      // Ignore events from browser extensions
      if (
        event.request?.url?.startsWith('chrome-extension://') ||
        event.request?.url?.startsWith('moz-extension://') ||
        event.request?.url?.startsWith('safari-extension://')
      ) {
        return null;
      }

      if (event.exception?.values) {
        const msg = event.exception.values.map(e => `${e.type} ${e.value}`).join(' ');

        if (toIgnore.some(v => msg.toLocaleLowerCase().includes(v.toLocaleLowerCase()))) {
          return null;
        }
      }

      return event;
    },
  });
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
